import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ParentsModal from '../Modals/ParentsModal';
import DataTable from '../../DataTable';
import { PlusCircle } from '@styled-icons/fa-solid';
import checkmark from '../../../images/checkmark.png';
import customer from '../../../images/customer.png';
import { StoreContext } from '../../Store';
import { useQueryClient } from '@tanstack/react-query';
import { getBusinessPartnerStatus, getBusinessPartnerParent } from '../../../api/v2/businessPartner';
import { useQuery } from '@tanstack/react-query';
import { getCustomerList } from '../../../api/v2/load';

export default function CM8Client() {
  const store = useContext(StoreContext);
  const [value, setValue] = useState(null);
  const [showParentsModal, setShowParentsModal] = useState(false);
  const [parents, setParents] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ['getCustomerList'],
    queryFn: () => getCustomerList(),
  });

  useEffect(() => {
    if (data) store.clientIDoptions[1](data);
  }, [data]);

  const queryClient = useQueryClient();

  const submit = async () => {
    store.clientID[1](value);
    const data = await queryClient.fetchQuery({
      queryKey: ['getBusinessPartnerStatus', value],
      queryFn: () => getBusinessPartnerStatus(value),
    });

    const valid = Object.keys(data)
      .filter((key) => key.includes('Valid'))
      .every((key) => data[key]);
    if (valid) {
      if (data?.BPType == 'PARENT') {
        store.newLoadParent[1]({
          parentId: data.id,
          parentName: data.companyName,
          parentEori: data.eori,
        });
        navigate(`/load/cm8/${value}`);
      } else {
        const businessPartnerId = data?.id;
        if (businessPartnerId) {
          const parents = await queryClient.fetchQuery({
            queryKey: ['getBusinessPartnerParent', businessPartnerId],
            queryFn: () => getBusinessPartnerParent(businessPartnerId),
          });
          const selectedParents = parents.filter((parent) => parent.checked);

          if (selectedParents.length === 1) {
            store.newLoadParent[1]({
              parentId: selectedParents[0].ParentTraderId,
              parentName: selectedParents[0].companyName,
              parentEori: selectedParents[0].eori,
            });
            navigate(`/load/cm8/${value}`);
            return;
          }

          setParents(selectedParents);
          setShowParentsModal(true);
        } else {
          navigate(`/load/cm8/${value}`);
        }
      }
    } else navigate(`/load/cm8/validation/${value}`);
  };

  const handleParentSelect = (parentId) => {
    setSelectedParent(parentId);
  };

  const handleContinue = async () => {
    if (selectedParent) {
      const parent = parents.find((p) => p.ParentTraderId === selectedParent);
      if (parent) {
        store.newLoadParent[1]({
          parentId: parent.ParentTraderId,
          parentName: parent.companyName,
          parentEori: parent.eori,
        });
      }
    }
    navigate(`/load/cm8/${value}`);
  };

  return (
    <>
      <ParentsModal
        showModal={showParentsModal}
        setShowModal={setShowParentsModal}
        onContinue={handleContinue}
        parents={parents}
        selectedParent={selectedParent}
        onParentSelect={handleParentSelect}
        value={value}
      />
      <div className="semi-fluid-container container-xl " style={{ maxWidth: '950px', marginTop: '4rem' }}>
        <div className="floating-box-newload">
          <div className="d-flex flex-column py-4 px-5">
            <h2 className="epo-steps-header">Select a Customer</h2>
            <div className="step-banner with-img" style={{ minHeight: '0' }}>
              <img src={customer} width="70" height="70" alt="port" />
              <p>Please select the customer from the list below you wish to link to this new load</p>
            </div>
            <div className="d-flex flex-column justify-content-md-start py-1 ">
              <DataTable
                dontRefreshPagination
                sortable
                filterable
                data={store.clientIDoptions[0] ?? []}
                className="table-bordered"
              >
                <DataTable.Pagination itemsPerPage={[5, 10, 20]} />
                <DataTable.Headers style={{ fontSize: '11px' }} />
                <DataTable.Row
                  className={(item) => {
                    if (item.id === value) {
                      return 'clientID-selected-row';
                    }
                    return '';
                  }}
                  style={{ fontSize: '16px' }}
                />
                <DataTable.Column colKey="companyName" header="Companies" />
                <DataTable.Column colKey="eori" header="EORI" />

                <DataTable.Column
                  header="Select"
                  style={{ height: '1px', padding: 0 }}
                  headerStyle={{ textAlign: 'center' }}
                >
                  {(query) => (
                    <button
                      className="external-table-link"
                      onClick={() => {
                        setValue(query.id);
                      }}
                    >
                      {query.id !== value ? (
                        <PlusCircle width="1.1rem" height="1.1rem" />
                      ) : (
                        <img src={checkmark} width="20px" alt="check" />
                      )}
                    </button>
                  )}
                </DataTable.Column>
              </DataTable>
            </div>
            <section className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="blue-button-teams"
                style={{ width: 'auto', padding: '0.25rem 1.45rem' }}
                disabled={!value}
                onClick={submit}
              >
                Continue
              </button>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
